import React, {
  Suspense,
  useEffect,
  useState,
  useSyncExternalStore,
} from "react";
import { AHQueryHandlerLoading, Box, ColorType } from "arkh";
import {
  Modal,

  Pressable,
  StyleSheet,
  View,
  ViewStyle,
} from "react-native";

import { useNavigation } from "@react-navigation/native";
import { WEB_MODAL_DEFAULT_WIDTH } from "./WEB_MODAL_DEFAULT_WIDTH";

const WEB_MODAL_DEFAULT_HEIGHT = 800;

let modal: symbol[] = [];
let listeners: (() => any)[] = [];

const modalStore = {
  getId() {
    return Symbol();
  },
  pushScreen(id: symbol) {
    modal = [...modal, id];
    emitChange();
    return id;
  },
  popScreen(id: symbol) {
    modal = modal.filter((i) => i !== id);
    emitChange();
    return id;
  },
  subscribe(listener: () => any) {
    listeners = [...listeners, listener];
    return () => {
      listeners = listeners.filter((l) => l !== listener);
    };
  },
  getSnapshot() {
    return modal;
  },
};

function emitChange() {
  for (const listener of listeners) {
    listener();
  }
}

export function WebModal(props: {
  children: React.ReactNode;
  dismissable?: boolean;
  width?: number;
  height?: number;
  color?: ColorType;
  shadow?: boolean;
  contentStyle?: ViewStyle;
  onRequestClose?: () => void;
}) {
  const height = props.height ?? WEB_MODAL_DEFAULT_HEIGHT;
  const width = props.width ?? WEB_MODAL_DEFAULT_WIDTH;

  const modals = useSyncExternalStore(
    modalStore.subscribe,
    modalStore.getSnapshot
  );

  const [modalId] = useState(() => modalStore.getId());

  useEffect(() => {
    modalStore.pushScreen(modalId);
    return () => {
      modalStore.popScreen(modalId);
    };
  }, [modalId]);

  

  const nav = useNavigation();
  const transition = { transition: "transform 0.3s" } as any;

  const isActive = modals.indexOf(modalId) + 1 === modals.length;
  

  return (
    <Modal
      visible
      transparent
      focusable={isActive}
      presentationStyle="overFullScreen"
      animationType="none"
      style={{ flex: 1 }}
      onRequestClose={() => {
        if (props.dismissable) {
          if (props.onRequestClose) {
            props.onRequestClose();
          } else {
            nav.goBack();
          }
        }
      }}
    >
      <View
        style={[
          StyleSheet.absoluteFill,
          {
            justifyContent: "center",
            alignItems: "center",
          },
        ]}
      >
        <Pressable
          style={[StyleSheet.absoluteFill]}
          onPress={() => {
            if (props.dismissable) {
              if (props.onRequestClose) {
                props.onRequestClose();
              } else {
                nav.goBack();
              }
            }
          }}
          aria-hidden
        >
          {modals.indexOf(modalId) === modals.length - 1 ? (
            <View
              style={[
                StyleSheet.absoluteFill,
                {
                  backdropFilter: "blur(1.6px)",
                  background: "rgba(0,0,0,0.1)",
                } as any,
              ]}
            />
          ) : null}
        </Pressable>
        <Box
          style={[
            {
              maxWidth: width,
              maxHeight: height,
              height: "95%",
              width: "95%",
              ...(props.shadow === false
                ? {}
                : {
                    shadowColor: "#000",
                    shadowOpacity: 0.2,
                    shadowRadius: 10,
                  }),
              overflow: "hidden",
              ...transition,
              transform: [
                {
                  translateY: modals.indexOf(modalId) * 15,
                },
                {
                  scale:
                    1 +
                    (modals.length - modals.indexOf(modalId)) * -0.01 +
                    0.01,
                },
              ],
            },
            props.contentStyle,
          ]}
          color={props.color ?? "surface"}
          cornerRadius="large"
          aria-modal
        >
          <Suspense fallback={<AHQueryHandlerLoading />}>
            {props.children}
          </Suspense>
        </Box>
      </View>
    </Modal>
  );
}
